<form
	class="sidebar__form {{ classViewOnlyForm }}"
	[formGroup]="form"
>	
	<h2 class="pax-title-h2">{{'bookingDetails.titles.personalDocuments' | ibeadmin:'sync'}}</h2>
	<p class="muted bottom-gap" *ngIf="isUSDestination">
		{{'bookingDetails.text.usaAuthoritiesInfo' | ibeadmin:'sync'}}
	</p>
	<p class="muted bottom-gap" *ngIf="hasImportedData">
		{{'bookingDetails.text.importedDetailsInfo' | ibeadmin:'sync'}}
	</p>
	<div class="form--edit-mode" *ngIf="displayMode === 'edit'">
		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<app-select-input-indra
					selectId="selectDocumentType"
					label="{{'bookingDetails.label.documentType' | ibeadmin:'sync'}}"
					placeholder="{{'bookingDetails.label.selectDocumentType' | ibeadmin:'sync'}}"
					formControlName="docType"
					id="personal-document--type"
					[options]="documentTypesOptions"
					selectLabel="{{'bookingDetails.label.selectDocumentType' | ibeadmin:'sync'}}"
				>
				</app-select-input-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formPersonalDocumentsErrors('docType') | ibeadmin:'sync'"
					*ngIf="form.controls['docType'].invalid && displayValidationMessages">
					{{ formPersonalDocumentsErrors('docType') | ibeadmin:'sync'}}
				</span>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="personal-document--number">
					{{'bookingDetails.label.documentNumber' | ibeadmin:'sync'}}
				</label>
				<input
					class="input-text"
					formControlName="docNum"
					id="personal-document--number"
					maxlength="15"
				/>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formPersonalDocumentsErrors('docNum') | ibeadmin:'sync'"
					*ngIf="form.controls['docNum'].invalid && displayValidationMessages">
					{{ formPersonalDocumentsErrors('docNum') | ibeadmin:'sync'}}
				</span>
			</div>
		</div>

		<div class="form-field--row grid no-padding">
			<div class="form-field no-margin col-6 col-tp-12 col-p-12">
				<app-date-form-indra
					uniqueId="expirationDate"
					label="{{'bookingDetails.label.expirationDate' | ibeadmin:'sync'}}"
					dayLabel="{{'bookingDetails.label.dayExpirationDate' | ibeadmin:'sync'}}"
					monthLabel="{{'bookingDetails.label.monthExpirationDate' | ibeadmin:'sync'}}"
					yearLabel="{{'bookingDetails.label.yearExpirationDate' | ibeadmin:'sync'}}"
					formControlName="expiryDate"
					[onlyFuture]="true"
					[disabled]="lifelong"
				>
				</app-date-form-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formPersonalDocumentsErrors('expiryDate') | ibeadmin:'sync'"
					*ngIf="form.controls['expiryDate'].invalid && displayValidationMessages"
				>
					{{ formPersonalDocumentsErrors('expiryDate') | ibeadmin:'sync'}}
				</span>
			</div>
			<div class="form-field col-4 col-tp-12 col-p-12 align-middle">
				<app-checkbox-input-indra
					class="checkbox-input--no-label-align"
					formControlName="lifelong"
					label="{{'bookingDetails.label.lifelong' | ibeadmin:'sync'}}"
				></app-checkbox-input-indra>
			</div>
		</div>

		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-12 col-p-12">
				<app-select-input-indra
					selectId="selectIssuingCountry"
					label="{{'bookingDetails.label.issuingCountry' | ibeadmin:'sync'}}"
					placeholder="{{'bookingDetails.label.selectIssuingCountry' | ibeadmin:'sync'}}"
					formControlName="country"
					id="personal-document--issuing_country"
					[optionsTranslated]="true"
					[options]="countryCodes"
					selectLabel="{{'bookingDetails.label.selectIssuingCountry' | ibeadmin:'sync'}}"
				>
				</app-select-input-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formPersonalDocumentsErrors('country') | ibeadmin:'sync'"
					*ngIf="form.controls['country'].invalid && displayValidationMessages"
				>
					{{ formPersonalDocumentsErrors('country') | ibeadmin:'sync'}}
				</span>
			</div>
			<div class="form-field col-6 col-tp-12 col-p-12">
				<app-select-input-indra
					selectId="selectNationality"
					label="{{'bookingDetails.label.nationality' | ibeadmin:'sync'}}"
					placeholder="{{'bookingDetails.label.selectNationality' | ibeadmin:'sync'}}"
					formControlName="nationallity"
					id="personal-document--nationality"
					[optionsTranslated]="true"
					[options]="countryCodes"
					selectLabel="{{'bookingDetails.label.selectNationality' | ibeadmin:'sync'}}"
				>
				</app-select-input-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formPersonalDocumentsErrors('nationallity') | ibeadmin:'sync'"
					*ngIf="form.controls['nationallity'].invalid && displayValidationMessages"
				>
					{{ formPersonalDocumentsErrors('nationallity') | ibeadmin:'sync'}}
				</span>
			</div>
		</div>

		<div class="form-field--row grid no-padding" *ngIf="!isInfant && !isChild && !isYoungAdult">
			<div class="form-field col-5 col-tp-12 col-p-12">
				<app-select-input-indra
					selectId="selectGender"
					label="{{'bookingDetails.label.gender' | ibeadmin:'sync'}}"
					placeholder="{{'bookingDetails.label.selectGender' | ibeadmin:'sync'}}"
					formControlName="gender"
					id="personal-document--gender"
					[options]="genderCodes"
					selectLabel="{{'bookingDetails.label.selectGender' | ibeadmin:'sync'}}"
				>
				</app-select-input-indra>
				<span
						aria-live="polite"
						class="input-error"
						role="alert"
						[attr.aria-label]="formPersonalDocumentsErrors('gender') | ibeadmin:'sync'"
						*ngIf="form.controls['gender'].invalid && displayValidationMessages"
					>
					{{ formPersonalDocumentsErrors('gender') | ibeadmin:'sync'}}
				</span>
			</div>
		</div>
		
		<div class="form-field--row grid no-padding" *ngIf="!isInfant && !isChild && !isYoungAdult">
			<div class="form-field no-margin col-6 col-tp-12 col-p-12">
				<app-date-form-indra
					uniqueId="dob"
					label="{{'bookingDetails.label.dateOfBirth' | ibeadmin:'sync'}}"
					dayLabel="{{'bookingDetails.label.dayOfBirth' | ibeadmin:'sync'}}"
					monthLabel="{{'bookingDetails.label.monthOfBirth' | ibeadmin:'sync'}}"
					yearLabel="{{'bookingDetails.label.yearOfBirth' | ibeadmin:'sync'}}"
					formControlName="birthDate"
					[onlyPast]="true"
					[paxType]="passengerInfo.typePax"
					[departureDate]="departureDate"
				>
				</app-date-form-indra>
				<span
					aria-live="polite"
					class="input-error"
					role="alert"
					[attr.aria-label]="formPersonalDocumentsErrors('birthDate') | ibeadmin:'sync'"
					*ngIf="form.controls['birthDate'].invalid && displayValidationMessages"
				>
					{{ formPersonalDocumentsErrors('birthDate') | ibeadmin:'sync'}}
				</span>
			</div>
		</div>

		<!-- Sprint 6 code merged note: this is not used in phase 2; add flag to hide this when in booking flow payment page  -->
		<!-- US Authorities -->
		<div *ngIf="isUSDestination">
			<div class="form-field--row grid no-padding" *ngIf="!isBookingPaymentPage">
				<div class="form-field col-6 col-tp-12 col-p-12">
					<app-select-input-indra
						selectId="selectStateOfResidence"
						placeholder="{{'bookingDetails.label.stateOfResidence' | ibeadmin:'sync'}}"
						formControlName="stateOrProvinceCode"
						id="personal-document--state"
						[options]="usStates"
						selectLabel="{{'bookingDetails.label.stateOfResidence' | ibeadmin:'sync'}}"
					>
					</app-select-input-indra>
					<span
						aria-live="polite"
						class="input-error"
						role="alert"
						[attr.aria-label]="formPersonalDocumentsErrors('stateOrProvinceCode') | ibeadmin:'sync'"
						*ngIf="form.controls['stateOrProvinceCode'].invalid && displayValidationMessages"
					>
						{{ formPersonalDocumentsErrors('stateOrProvinceCode') | ibeadmin:'sync'}}
					</span>
				</div>

				<div class="form-field col-6 col-tp-6 col-p-12">
					<label class="label" for="personal-document--address">
						{{'bookingDetails.label.addressOfFirst' | ibeadmin:'sync'}}
					</label>
					<input
						class="input-text"
						formControlName="address"
						maxlength="35"
						placeholder="{{'bookingDetails.label.insertAddress' | ibeadmin:'sync'}}"
						id="personal-document--address"
					/>
					<span
						aria-live="polite"
						class="input-error"
						role="alert"
						[attr.aria-label]="formPersonalDocumentsErrors('address') | ibeadmin:'sync'"
						*ngIf="form.controls['address'].invalid && displayValidationMessages"
					>{{ formPersonalDocumentsErrors('address') | ibeadmin:'sync'}}</span>
				</div>
			</div>
			<div class="form-field--row grid no-padding" *ngIf="!isBookingPaymentPage">
				<div class="form-field col-4 col-tp-4 col-p-12">
					<label class="label" for="personal-document--zip_code">
						{{'bookingDetails.label.zipCode' | ibeadmin:'sync'}}
					</label>
					<input
						class="input-text"
						formControlName="postalCode"
						placeholder="{{'bookingDetails.label.insertZipCode' | ibeadmin:'sync'}}"
						id="personal-document--zip_code"
					/>
					<span aria-live="polite" class="input-error" role="alert"
						[attr.aria-label]="formPersonalDocumentsErrors('postalCode') | ibeadmin:'sync'"
						*ngIf="form.controls['postalCode'].invalid && displayValidationMessages">
						{{ formPersonalDocumentsErrors('postalCode') | ibeadmin:'sync'}}
					</span>
				</div>

				<div class="form-field col-8 col-tp-8 col-p-12">
					<label class="label" for="personal-document--city">
						{{'bookingDetails.label.city' | ibeadmin:'sync'}}
					</label>
					<input
						class="input-text"
						formControlName="city"
						placeholder="{{'bookingDetails.label.insertCity' | ibeadmin:'sync'}}"
						id="personal-document--city"
					/>
					<span
						aria-live="polite"
						class="input-error"
						role="alert"
						[attr.aria-label]="formPersonalDocumentsErrors('city') | ibeadmin:'sync'"
						*ngIf="form.get('city').invalid && displayValidationMessages">
						{{ formPersonalDocumentsErrors('city') | ibeadmin:'sync'}}
					</span>
				</div>
			</div>
		</div>
		<a
			class="link right-gap" href="javascript:;"
			(click)="clearForm()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.text.clearDetails' | ibeadmin:'sync'}}</a>
		<a
			class="link" href="javascript:;"
			(click)="cancelEdit()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.text.cancelEditing' | ibeadmin:'sync'}}
		</a>
		
		<hr class="separator">
	</div>

	<div class="form--view-mode" *ngIf="displayMode === 'view' && hasData">
		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.documentType' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.docType | documentTypeDesc | ibeadmin:'sync'}}</span>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.documentNumber' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.docNum }}</span>
			</div>
		</div>
		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.dateOfBirth' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.birthDate | dateIndra }}</span>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.documentExpiration' | ibeadmin:'sync'}}</span>
				<span class="value">{{ form.value?.expiryDate | dateIndra }}</span>
			</div>
		</div>
		<div class="form-field--row grid no-padding">
				<div class="form-field col-6 col-tp-6 col-p-12">
					<span class="label">{{'bookingDetails.label.issuingCountry' | ibeadmin:'sync'}}</span>
					<span class="value">{{ form.value.country | countryDesc }}</span>
				</div>
				<div class="form-field col-6 col-tp-6 col-p-12">
					<span class="label">{{'bookingDetails.label.nationality' | ibeadmin:'sync'}}</span>
					<span class="value">{{ form.value.nationallity | countryDesc }}</span>
				</div>
			</div>
	</div>

	<button
		class="button button-main-line top-gap"
		(click)="openEditForm()"
		*ngIf="displayMode === 'view'">
		{{'bookingDetails.text.editPersonalDocuments' | ibeadmin:'sync'}}
	</button>
</form>
